import { Role } from 'types/enums';

export const ROUTES = {
  home: '/',
  heatmap: '/heatmap',
  manageClients: '/manage_clients',
  editClientNamespace: '/edit_client/',
  editClient: '/edit_client/:id',
  manageSystemAdmins: '/manage_system_admins',
  manageClientAdmins: '/manage_client_admins',
  profile: '/profile',
  settings: '/settings',
  maintenance: '/maintenance',
  searchPlanograms: '/search_planograms',
  migrationReports: '/maintenance/migration_reports',
  migrationReportNamespace: '/maintenance/migration_reports/',
  migrationReport: '/maintenance/migration_reports/:id',
  purchasingFlowSettings: '/settings/purchasing-flow',
  currencySettings: '/settings/currency',
  errorResponseSettings: '/settings/error-response',
  ecommerceProviders: '/settings/ecommerce-providers',
  ecommerceProviderSettingsNamespace: '/settings/ecommerce-providers/',
  ecommerceProviderSettings: '/settings/ecommerce-providers/:id',
  ssoProviders: '/settings/sso-providers',
  ssoProviderSettingsNamespace: '/settings/sso-providers/',
  ssoProviderSettings: '/settings/sso-providers/:id',
  ecommerceOverlays: '/settings/ecommerce-overlay',
  editSystemAdminNamespace: '/edit_system_admin/',
  editClientAdminNamespace: '/edit_client_admin/',
  editSystemAdmin: '/edit_system_admin/:id',
  editClientAdmin: '/edit_client_admin/:id',
  manageProducts: '/manage_products',
  newProduct: '/new_product',
  editProductNamespace: '/edit_product/',
  editProduct: '/edit_product/:id',
  manageSpheres: '/manage_spheres',
  showSphere: '/spheres/:id',
  manageSpheresSettings: '/spheres/:id/settings',
  manageCategories: '/manage-categories',
  manageTags: '/tags',
  manageImages: '/images',
  authSignIn: '/auth/sign-in',
  authSignUp: '/auth/sign-up',
  inviteSelector: '/auth/sign-up-with-invite',
  signUpWithInvite: '/auth/setup-with-email',
  socialSignUpWithInvite: '/auth/sign-up-with-invite-social',
  profileSetupError: '/auth/profile-setup-error',
  setPassword: '/auth/set-password',
  linkExpired: '/auth/link-expired',
  authOktaComplete: '/auth/okta-complete',
  createPassword: '/auth/create-password',
  resetPassword: '/auth/reset-password',
  authGoogleSignUp: '/auth/google-sign-up',
  authGoogleAccountNotFound: '/auth/google-account-not-found',
  chooseSpace: '/auth/choose-space',
  confirmCloning: '/auth/confirm-cloning',
  declineCloning: '/auth/decline-cloning',
  cloningExpired: '/auth/cloning-expired',
  page404: '/auth/404',
  page500: '/auth/500',
  curatorNamespace: '/curator/',
  assets: '/assets',
  logo: '/logo',
  faviconAssets: '/assets/favicon',
  fontsAssets: '/assets/fonts',
  controlButtonAssets: '/assets/control-button',
  backgroundImagesAssets: '/assets/background-images',
  otherAssets: '/assets/other-assets',
  overlayContent: '/assets/overlay-content',
  videoAssets: '/assets/videos',
  audioAssets: '/assets/audio',
  cookiesSettings: '/settings/cookies',
  overlaysSettings: '/settings/overlays',
  manageSpace: '/manage_space',
  manageClientModerators: '/manage_client_moderators',
  manageBuilderAdmins: '/manage_builder_admins',
  editClientModeratorNamespace: '/edit_client_moderator/',
  editClientModerator: '/edit_client_moderator/:id',
  editBuilderAdminNamespace: '/edit_builder_admin/',
  editBuilderAdmin: '/edit_builder_admin/:id',
  tFASettingsNew: '/two_factor_setting/new',
  resetTFA: '/two_factor_settings/reset_two_factor',
  manageReservedClients: '/reserved_clients',
  createTestPlanogram: '/create_test_planogram',
  analyticsProviders: '/settings/analytics_providers',
  googleTagManager: '/settings/analytics_providers/google-tag-manager',
  domainManagementSettings: '/settings/domain-management',
  billingSettings: '/settings/billing',
  socialIntegration: '/settings/social-medias',
  socialIntegrationNamespace: '/settings/social-medias/',
  socialIntegrationSettings: '/settings/social-medias/:id',
  socialContent: '/manage_social_content',
  matomoAnalytics: '/settings/analytics_providers/matomo',
  animationSettings: '/settings/animation',
  AbTesting: '/settings/testing',
  userPayments: '/settings/user_payments',
  connectFigma: '/figma-connected',
};

export const ROLES = {
  systemAdmin: Role.SYSTEM_ADMIN,
  clientAdmin: Role.CLIENT_ADMIN,
  clientOwner: Role.CLIENT_OWNER,
  clientModerator: Role.CLIENT_MODERATOR,
  builderAdmin: Role.BUILDER_ADMIN,
};

export const ROLES_DISPLAY_MAP = {
  [ROLES.systemAdmin]: 'system_admin',
  [ROLES.clientOwner]: 'space_owner',
  [ROLES.clientAdmin]: 'space_admin',
  [ROLES.clientModerator]: 'space_moderator',
  [ROLES.builderAdmin]: 'builder_admin',
};

// TODO refactor roles permissions due to role updates
export const RESTRICTED_ROUTE_PERMISSIONS = {
  [ROUTES.home]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.heatmap]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.manageClients]: [ROLES.systemAdmin],
  [ROUTES.editClientNamespace]: [ROLES.systemAdmin],
  [ROUTES.editClient]: [ROLES.systemAdmin],
  [ROUTES.manageSystemAdmins]: [ROLES.systemAdmin],
  [ROUTES.manageClientAdmins]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.profile]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.settings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.purchasingFlowSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.currencySettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.errorResponseSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.ecommerceProviders]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ecommerceProviderSettingsNamespace]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ecommerceProviderSettings]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ssoProviders]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ssoProviderSettingsNamespace]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ssoProviderSettings]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.ecommerceOverlays]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.editSystemAdminNamespace]: [ROLES.systemAdmin],
  [ROUTES.editClientAdminNamespace]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.editSystemAdmin]: [ROLES.systemAdmin],
  [ROUTES.editClientAdmin]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.manageProducts]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.newProduct]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.editProductNamespace]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.editProduct]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageSpheres]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.showSphere]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator, ROLES.systemAdmin],
  [ROUTES.manageSpheresSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageCategories]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageTags]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageImages]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.assets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.logo]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.faviconAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.fontsAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.controlButtonAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.backgroundImagesAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.otherAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.overlayContent]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.videoAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.audioAssets]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.cookiesSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.overlaysSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageSpace]: [ROLES.systemAdmin, ROLES.clientOwner],
  [ROUTES.manageClientModerators]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.editClientModeratorNamespace]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.editClientModerator]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.editBuilderAdminNamespace]: [ROLES.systemAdmin],
  [ROUTES.editBuilderAdmin]: [ROLES.systemAdmin],
  [ROUTES.manageReservedClients]: [ROLES.systemAdmin],
  [ROUTES.analyticsProviders]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.googleTagManager]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.domainManagementSettings]: [ROLES.clientOwner, ROLES.clientAdmin],
  [ROUTES.billingSettings]: [ROLES.clientOwner],
  [ROUTES.maintenance]: [ROLES.systemAdmin],
  [ROUTES.searchPlanograms]: [ROLES.systemAdmin],
  [ROUTES.migrationReports]: [ROLES.systemAdmin],
  [ROUTES.migrationReportNamespace]: [ROLES.systemAdmin],
  [ROUTES.migrationReport]: [ROLES.systemAdmin],
  [ROUTES.socialIntegration]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.socialIntegrationNamespace]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.socialIntegrationSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.socialContent]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.matomoAnalytics]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.animationSettings]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.userPayments]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.AbTesting]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.connectFigma]: [ROLES.clientOwner, ROLES.clientAdmin, ROLES.clientModerator],
  [ROUTES.manageBuilderAdmins]: [ROLES.systemAdmin, ROLES.clientOwner, ROLES.clientAdmin],
};

export const PUBLIC_ROUTES = Object.values(ROUTES).filter(path => !RESTRICTED_ROUTE_PERMISSIONS[path]);

export const ROUTES_WITHOUT_DASHBOARD = [ROUTES.home, ROUTES.connectFigma];
